import {
    RESET_PLAYERS,
    GET_ALL_PLAYERS,
    GET_ALL_PLAYERS_SUCCESS,
    GET_ALL_PLAYERS_ERROR,
    ASSIGN_COACH_TO_PLAYER,
    ASSIGN_COACH_TO_PLAYER_SUCCESS,
    ASSIGN_COACH_TO_PLAYER_ERROR,
    CHANGE_COACH_TO_PLAYER,
    CHANGE_COACH_TO_PLAYER_SUCCESS,
    CHANGE_COACH_TO_PLAYER_ERROR,
    REMOVE_COACH_TO_PLAYER,
    REMOVE_COACH_TO_PLAYER_SUCCESS,
    REMOVE_COACH_TO_PLAYER_ERROR,
    SELECT_PLAYER
} from '../constants/ActionTypes';

export const resetPlayers = () => {
    return {
        type: RESET_PLAYERS,
    };
};

export const getAllPlayers = (sessionToken) => {
    return {
        type: GET_ALL_PLAYERS,
        payload: sessionToken
    };
};

export const getAllPlayersSuccess = (playerResponse) => {
    return {
        type: GET_ALL_PLAYERS_SUCCESS,
        payload: playerResponse
    };
};

export const getAllPlayersError = (playerResponse) => {
    return {
        type: GET_ALL_PLAYERS_ERROR,
        payload: playerResponse
    };
};

export const assignCoachToPlayer = (payload) => {
    return {
        type: ASSIGN_COACH_TO_PLAYER,
        payload: payload
    };
};

export const assignCoachToPlayerSuccess = (playerResponse) => {
    return {
        type: ASSIGN_COACH_TO_PLAYER_SUCCESS,
        payload: playerResponse
    };
};

export const assignCoachToPlayerError = (playerResponse) => {
    return {
        type: ASSIGN_COACH_TO_PLAYER_ERROR,
        payload: playerResponse
    };
};

export const changeCoachToPlayer = (payload) => {
    return {
        type: CHANGE_COACH_TO_PLAYER,
        payload: payload
    };
};

export const changeCoachToPlayerSuccess = (playerResponse) => {
    return {
        type: CHANGE_COACH_TO_PLAYER_SUCCESS,
        payload: playerResponse
    };
};

export const changeCoachToPlayerError = (playerResponse) => {
    return {
        type: CHANGE_COACH_TO_PLAYER_ERROR,
        payload: playerResponse
    };
};

export const removeCoachToPlayer = (payload) => {
    return {
        type: REMOVE_COACH_TO_PLAYER,
        payload: payload
    };
};

export const removeCoachToPlayerSuccess = (playerResponse) => {
    return {
        type: REMOVE_COACH_TO_PLAYER_SUCCESS,
        payload: playerResponse
    };
};

export const removeCoachToPlayerError = (playerResponse) => {
    return {
        type: REMOVE_COACH_TO_PLAYER_ERROR,
        payload: playerResponse
    };
};

export const selectPlayer = (player) => {
    return {
        type: SELECT_PLAYER,
        payload: player
    };
};
